import { useState, useRef } from 'react';

export const useEditorManagement = () => {
  const [editorInitialized, setEditorInitialized] = useState(false);
  const [stepOneEditorInitialized, setStepOneEditorInitialized] =
    useState(false);
  const editorRef = useRef(null);
  const stepOneEditorRef = useRef(null);

  const handleEditorInit = (editor) => {
    editorRef.current = editor;
    setEditorInitialized(true);
  };

  const handleStepOneEditorInit = (editor) => {
    stepOneEditorRef.current = editor;
    setStepOneEditorInitialized(true);
  };

  return {
    editorRef,
    stepOneEditorRef,
    editorInitialized,
    stepOneEditorInitialized,
    handleEditorInit,
    handleStepOneEditorInit,
  };
};
